<div class="container" *transloco="let t">
  <div class="title box">
    <div class="title">
      <span>{{ t('POPUPS.QUESTION-LIST.TITLE') }}</span>
      <app-progress *ngIf="!readonly" class="progress" [progress]="progress" type="linear"></app-progress>
    </div>
    <div>
      <app-svg-icon class="white" [path]="'/assets/closebutton.svg'" (click)="closeEvent.emit(true)"></app-svg-icon>
    </div>
  </div>
  <div class="status box">
    <app-distribution-bar [data]="questionList"></app-distribution-bar>
    <div class="status-container">
      <div *ngFor="let state of filterOptions" [ngClass]="[setClass(state.option), setSelected(state.option)]"
           (click)="setFilterList(state)">{{setDisplayName(state.option)}}</div>
    </div>
  </div>
  <div class="question box">
    <div class="item" *ngFor="let item of unAnsweredQuestionList" [ngClass]="setClass(item.state)" (click)="openQuestion(item.id)">
      #{{item.number + 1}} {{item.name}}</div>
    <div *ngIf="unAnsweredQuestionList.length > 0" class="separator"></div>
    <div class="item" *ngFor="let item of answeredQuestionList" [ngClass]="setClass(item.state)" (click)="openQuestion(item.id)">
      #{{item.number + 1}} {{item.name}}</div>
  </div>
</div>
